import { useEffect } from 'react';
import { capturePostHogException } from '@/components/entities/analytics/components/PostHog/utils/postHogExceptionCapture';
import { Env } from '@/consts/Env';

type PostHogErrorBoundary = 'route' | 'global';

export function useCapturePostHogException(error: Error & { digest?: string }, errorBoundary: PostHogErrorBoundary) {
  useEffect(() => {
    capturePostHogException(error, {
      app_environment: Env.NEXT_PUBLIC_ENVIRONMENT,
      ...(Env.NEXT_PUBLIC_APP_RELEASE ? { app_release: Env.NEXT_PUBLIC_APP_RELEASE } : {}),
      ...(error.digest ? { nextjs_digest: error.digest } : {}),
      error_boundary: errorBoundary,
    });
  }, [error, errorBoundary]);
}
